import { type MoneymapItem } from "@src/api";
import type { ShopZoneExtended } from "@src/store";
import type { MoneymapItemWithTitle } from "./moneymap";

const EMPTY_ZONE_ITEM: Omit<MoneymapItemWithTitle, "zone_id" | "title"> = {
  is_zone: true,
  is_link: false,
  records_total: 0,
  amount_total: "0",
  quantity_total: 0,
};

/**
 * Сливает дочерние зоны (zone.children) с данными moneymap: сохраняет порядок детей,
 * подставляет статистику где есть, добавляет в конец элементы moneymap без соответствующей дочерней зоны.
 */
export function mergeZoneMoneymapData(
  zone: ShopZoneExtended,
  moneymapData: MoneymapItem[],
  zoneMap: Record<string, ShopZoneExtended>
): MoneymapItemWithTitle[] {
  const result: MoneymapItemWithTitle[] = [];
  const children = zone.children ?? [];

  const zoneById = children.reduce<Record<string, ShopZoneExtended>>((acc, cur) => {
    if (!acc[cur.zone_id]) acc[cur.zone_id] = cur;
    return acc;
  }, {});

  const moneymapById = moneymapData.reduce<Record<string, MoneymapItem>>((acc, cur) => {
    if (!acc[cur.zone_id]) acc[cur.zone_id] = cur;
    return acc;
  }, {});

  children.forEach((item) => {
    if (moneymapById[item.zone_id]) {
      result.push({ ...moneymapById[item.zone_id], title: item.title });
    } else {
      result.push({
        zone_id: item.zone_id,
        title: item.title,
        ...EMPTY_ZONE_ITEM,
      });
    }
  });

  moneymapData.forEach((item) => {
    if (!zoneById[item.zone_id]) {
      const itemZone = zoneMap[item.zone_id];
      result.push({ ...item, title: itemZone?.title });
    }
  });

  return result;
}
